// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-custom-gearset-btn {
  border: 1px solid var(--color-darker);
  border-radius: 1rem;
  padding-left: 3%;
  padding-right: 3%;
  color: var(--color-darkest);
  background: var(--color-middle);
  transition: background-color 0.3s;
}

.add-custom-gearset-btn:hover {
  border: 1px solid var(--color-light);
  background: var(--color-darker);
  color: var(--color-light);
  cursor: pointer;
}

.container_custom {
  display: grid;
  grid-template-areas:
    "heading heading heading heading button "
    "table   table   table   table   table  "
    "graphs  graphs  graphs  graphs  graphs ";
  grid-auto-rows: auto auto 1fr;
  gap: 1%;
}

.add-custom-gearset-btn {
  grid-area: button;
}

/* gear list as a whole - grid */
#custom-gear-list {
  grid-area: table;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1%;
  --width-no: 5vw;
  --width-front: 10vw;
  --width-back: 20vw;
}

/* individual row - also grid */
#custom-gear-list > div {
  padding: 1%;
  display: grid;
  grid-template-columns: 3vw 5vw 20vw 30vw;
  gap: 3%;
  overflow: visible;
  border: 1px solid var(--color-darker);
  border-radius: 1rem;
  align-items: center;
}

button.delete-button {
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  color: red;
  cursor: pointer;
  align-self: center;
  justify-self: center;
}

.front-gear {
  justify-self: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/static/css/tabCustom.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb;;;6CAG2C;EAC3C,6BAA6B;EAC7B,OAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,OAAO;EACP,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,aAAa;EACb,wCAAwC;EACxC,OAAO;EACP,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".add-custom-gearset-btn {\n  border: 1px solid var(--color-darker);\n  border-radius: 1rem;\n  padding-left: 3%;\n  padding-right: 3%;\n  color: var(--color-darkest);\n  background: var(--color-middle);\n  transition: background-color 0.3s;\n}\n\n.add-custom-gearset-btn:hover {\n  border: 1px solid var(--color-light);\n  background: var(--color-darker);\n  color: var(--color-light);\n  cursor: pointer;\n}\n\n.container_custom {\n  display: grid;\n  grid-template-areas:\n    \"heading heading heading heading button \"\n    \"table   table   table   table   table  \"\n    \"graphs  graphs  graphs  graphs  graphs \";\n  grid-auto-rows: auto auto 1fr;\n  gap: 1%;\n}\n\n.add-custom-gearset-btn {\n  grid-area: button;\n}\n\n/* gear list as a whole - grid */\n#custom-gear-list {\n  grid-area: table;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1%;\n  --width-no: 5vw;\n  --width-front: 10vw;\n  --width-back: 20vw;\n}\n\n/* individual row - also grid */\n#custom-gear-list > div {\n  padding: 1%;\n  display: grid;\n  grid-template-columns: 3vw 5vw 20vw 30vw;\n  gap: 3%;\n  overflow: visible;\n  border: 1px solid var(--color-darker);\n  border-radius: 1rem;\n  align-items: center;\n}\n\nbutton.delete-button {\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: none;\n  color: red;\n  cursor: pointer;\n  align-self: center;\n  justify-self: center;\n}\n\n.front-gear {\n  justify-self: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
